import {Selector} from '@ngxs/store';
import {AdvertiserCampaignDevicesState} from './advertiser-campaign-devices.state';
import {AdvertiserCampaignDevicesModel} from './advertiser-campaign-devices.model';
import {IDeviceAdvertiserCampaign} from '@interfaces/advertiser/devices';

export class AdvertiserCampaignDevicesSelectors {
  @Selector([AdvertiserCampaignDevicesState])
  static getCampaignDevices(state: AdvertiserCampaignDevicesModel): IDeviceAdvertiserCampaign[] {
    return state.devices;
  }

  @Selector([AdvertiserCampaignDevicesState])
  static getSelectedDevices(state: AdvertiserCampaignDevicesModel): IDeviceAdvertiserCampaign[] {
    return state.selectedDevices;
  }

  @Selector([AdvertiserCampaignDevicesState])
  static getSelectedDevicesFromDB(state: AdvertiserCampaignDevicesModel): number[] {
    return state.selectedDevicesFromDb;
  }

  @Selector([AdvertiserCampaignDevicesState])
  static isSelectedDevicesDisplaying(state: AdvertiserCampaignDevicesModel): boolean {
    return state.showSelectedDevices;
  }

  @Selector([AdvertiserCampaignDevicesState])
  static getSearchValue(state: AdvertiserCampaignDevicesModel): string {
    return state.search;
  }
}
